jQuery(document).ready(function ($) {
    "use strict";

    $( '.blog-listings__select' ).on( 'change', function(){
        location.href = $( this ).val();
        $( this ).prop( 'selectedIndex', 0 );
    });
});
